import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Output() pageNumber = new EventEmitter<string>();
  @Output() pagesizeData = new EventEmitter<string>();
  @Input() page: number;
  @Input() totalData: number;
  @Input() pageSize: string;
  @Input() isShowMachineCount: boolean = false;
  @Input() totalMachineCount: number = 0;
  @Input() machineStatus: string = '';
  @Input() totalFilterMachineDataByStatus: number = 0;
  totalPage: any;
  ChangeArray: any[] = [];
  pafinateArray: any[] = [];

  pageSizeList: any[] = [
    { label: 100, value: '100' },
    // { label : 250, value : '250'},
    // { label : 500, value : '500'},
    // { label : 1000, value : '1000'},
  ];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.pageCount()
  }

  pageCount() {
    this.totalPage = Math.round(Math.ceil(+this.totalData / +this.pageSize));

    if (Math.round(this.totalPage) <= 1) {
      this.ChangeArray = [];
      this.ChangeArray.push('1')
      this.pafinateArray = [];
      this.pafinateArray.push('1')
    } else {
      this.ChangeArray = [];
      this.pafinateArray = [];
      for (let i = 1; i <= this.totalPage; i++) {
        this.ChangeArray.push(i)
        this.pafinateArray.push(i)
      }
      this.changeArray(this.pafinateArray, this.page)
    }
  }
  changeArray(array, page) {
    let totalcount = array.length;
    let arr1 = []
    if (array.length >= 4) {
      arr1.push(1);
      if (page > 3) { arr1.push("...") }
      if (page == totalcount) { arr1.push(page - 2); }
      if (page > 2) { arr1.push(page - 1); }
      if (page != 1 && page != totalcount) { arr1.push(page); }
      if (page < totalcount - 1) { arr1.push(page + 1); }
      if (page == 1) { arr1.push(page + 2) }
      if (page < totalcount - 2) { arr1.push("...") }
      arr1.push(totalcount);
      this.ChangeArray = arr1;
    }
  }

  onPreview() {
    const page = this.page - 1;
    this.onPaginationClick(page);
  }
  onNext() {
    const page = this.page + 1;
    this.onPaginationClick(page);
  }
  onPaginationClick(value) {
    if (value !== '...') {
      if (value == this.page) {
        return;
      }
      this.changeArray(this.pafinateArray, value);
      this.pageNumber.emit(value);
    }
  }
  onSelectPageLangth() {
    this.pageSize = this.pageSize;
    this.pageCount()
    this.pagesizeData.emit(this.pageSize)
  }
}
